/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */

namespace network_ui {

   class VmMigrateSelectVmsPageController {

      public static $inject = [
         "$scope",
         "i18nService",
         "columnRenderersRegistry",
         "vmMigrateWizardConstants",
         "dataService",
         "defaultUriSchemeUtil",
         "clarityModalService",
         "$element",
         "vuiUtils",
         "$q",
         "vmMigrateSelectVmsPageService"];

      public selectVmsInfo: string;
      public treeListWidget: any;
      public treeListOptions: any;

      private bindTreeListEvents: boolean;
      private restoreExpandedItems: boolean;

      constructor(private $wizardScope: VmMigrateWizardScope,
                  private i18nService: any,
                  private columnRenderersRegistry: any,
                  private wizardConstants: any,
                  private dataService: any,
                  private defaultUriSchemeUtil: any,
                  private clarityModalService: any,
                  private $element: JQuery,
                  private vuiUtils: any,
                  private $q: any,
                  private vmMigrateSelectVmsPageService: VmMigrateSelectVmsPageService) {

         this.bindTreeListEvents = true;
         this.restoreExpandedItems = true;
         this.treeListOptions = {
            columns: this.getTreeListColumnDefs(),
            sortable: false,
            resizable: true,
            selectable: true,
            dataBound: this.onTreeListDataBound.bind(this),
            expand: (event: any) => {
               vuiUtils.safeApply(this.$wizardScope, this.onExpandItem.bind(this, event));
            },
            collapse: (event: any) => {
               vuiUtils.safeApply(this.$wizardScope, this.onCollapseItem.bind(this, event));
            }
         };

         this.selectVmsInfo = this.$wizardScope.flags.noSourceNetworkSelected
               ? this.i18nService.getString("NetworkUi",
                     "SelectVmsToMigratePage.selectVmsLabelNoSource",
                     this.$wizardScope.model.destinationNetwork.name)
               : this.i18nService.getString("NetworkUi",
                     "SelectVmsToMigratePage.selectVmsLabel",
                     this.$wizardScope.model.sourceNetwork.name,
                     this.$wizardScope.model.destinationNetwork.name);

         if (!this.$wizardScope.flags.isSelectVmsPageInitialized) {
            this.requestProperties();
         } else {
            this.initTreeListData();
         }

         $element.on('vmMigrateSelectVm', (event, dataItemUid) => {
            event.stopPropagation();

            let items: any[] = this.treeListOptions.dataSource.rootNodes();
            for (let i = 0; i < items.length; i++) {
               items = items.concat(this.treeListOptions.dataSource.childNodes(items[i]));
            }
            let item: any = _.filter(items, (item) => item.uid === dataItemUid)[0];
            item.isChecked = !item.isChecked;
            this.onCheckboxClick(item);
         });
      }

      private requestProperties() : void {
         this.$wizardScope.wizardConfig.loading = true;

         let networkId: string = this.defaultUriSchemeUtil.getVsphereObjectId(
               this.$wizardScope.model.destinationNetwork.networkRef);

         let spec: any = {
            sourceNetworkRef: this.$wizardScope.flags.noSourceNetworkSelected
                  ? null
                  : this.$wizardScope.model.sourceNetwork.networkRef,
            datacenterRef: this.defaultUriSchemeUtil.getManagedObjectReference(
                  this.$wizardScope.model.datacenterId)
         };

         this.dataService.getProperties(
               networkId,
               [this.wizardConstants.properties.VM_NETWORKS_PROPERTY],
               {
                  propertyParams: [{
                     propertyName: this.wizardConstants.properties.VM_NETWORKS_PROPERTY,
                     parameterType: this.wizardConstants.specs.VM_MIGRATE_PROPERTY_SPEC,
                     parameter: spec
                  }]
               })
               .then((response: any): void => {
                  let vmData: any = response[
                        this.wizardConstants.properties.VM_NETWORKS_PROPERTY];

                  this.$wizardScope.model.destinationNetworkData =
                        vmData.destinationNetwork;
                  this.$wizardScope.model.treeListItemData =
                        vmData.vmListItems;

                  this.$wizardScope.wizardConfig.loading = false;
                  this.$wizardScope.flags.isSelectVmsPageInitialized = true;

                  this.initTreeListData();

                  this.restoreExpandedItems = true;
               });
      }

      public onExpandItem(e: any) {
         this.vmMigrateSelectVmsPageService.saveExpandedItem(
               e.model.id,
               this.$wizardScope.model.expandedItemIds);
      }

      public onCollapseItem(e: any) {
         this.vmMigrateSelectVmsPageService.saveCollapsedItem(
               e.model.id,
               this.$wizardScope.model.expandedItemIds);
      }

      public onTreeListDataBound() {
         if (!this.restoreExpandedItems || !this.treeListWidget) {
            return;
         }

         this.vmMigrateSelectVmsPageService.restoreExpandedItems(
               this.$wizardScope.model.expandedItemIds,
               this.treeListWidget,
               this.treeListOptions.dataSource);
         this.restoreExpandedItems = false;
      }

      private initTreeListData(): void {
         this.treeListOptions.dataSource = new kendo.data.TreeListDataSource({
            data: !this.$wizardScope.model.treeListItemData ?
                  [] : this.$wizardScope.model.treeListItemData,
            schema:  {
               model: {
                  id: "id",
                  expanded: false
               }
            }
         });

         this.treeListOptions.dataSource.read();
      }

      public getTreeListColumnDefs(): any[] {
         let columnRenderer: any = this.columnRenderersRegistry
               .getColumnRenderer('disabled-text-icon-with-tooltip');
         return [
            {
               field: "name",
               title: this.i18nService.getString(
                     "NetworkUi", "SelectVmsToMigratePage.vmNicColumnHeader"),
               width: "240px",
               template: function(dataItem: any) {
                  let disabledClass: string = dataItem.isAccessible === false ?
                        "element-disabled" : "";
                  return "<input type=\"checkbox\" " +
                        "    " + (dataItem.isChecked ? "checked" : "") +
                        "    onclick=\"$(this).trigger('vmMigrateSelectVm', '" + dataItem.uid + "')\"" +
                        "    class=\"" + disabledClass + "\"/>" +
                        "<span ng-non-bindable>" +
                        columnRenderer(["icon", "label", "disabled", "tooltip"], {
                           icon: dataItem.iconId,
                           label: dataItem.name,
                           disabled: dataItem.isAccessible === false,
                           tooltip: dataItem.itemTooltip
                        }) +
                        "</span>";
               }
            },
            {
               field: "nicCount",
               width: "100px",
               title: this.i18nService.getString(
                     "NetworkUi", "SelectVmsToMigratePage.nicsCountColumnHeader"),
               template: function(dataItem: any) {
                  return columnRenderer(["icon", "label", "disabled", "tooltip"], {
                     icon: null,
                     label: dataItem.nicCount,
                     disabled: dataItem.isAccessible === false,
                     tooltip: dataItem.itemTooltip
                  });
               }
            },
            {
               field: "host",
               title: this.i18nService.getString(
                     "NetworkUi", "SelectVmsToMigratePage.hostColumnHeader"),
               width: "150px",
               template: function(dataItem: any) {
                  return columnRenderer(["icon", "label", "disabled", "tooltip"], {
                     icon: dataItem.hostName ? "vsphere-icon-host" : null,
                     label: dataItem.hostName,
                     disabled: dataItem.isAccessible === false,
                     tooltip: dataItem.itemTooltip
                  });
               }
            },
            {
               field: "accessibility",
               title: this.i18nService.getString(
                     "NetworkUi", "SelectVmsToMigratePage.destNetworkColumnHeader"),
               template: (dataItem: any) => {
                  let accessibility: string = "";

                  if (dataItem.isAccessible) {
                     accessibility = this.i18nService.getString(
                           "NetworkUi", "SelectVmsToMigratePage.accessible");
                  } else if (dataItem.isAccessible === false) {
                     accessibility = this.i18nService.getString(
                           "NetworkUi", "SelectVmsToMigratePage.inaccessible");
                  }
                  return columnRenderer(["icon", "label", "disabled", "tooltip"], {
                     icon: null,
                     label: accessibility,
                     disabled: dataItem.isAccessible === false,
                     tooltip: dataItem.itemTooltip
                  });
               }
            }];
      }

      private onCheckboxClick(dataItem: any): void {
         this.vmMigrateSelectVmsPageService.updateTreeListCheckboxState(
               this.treeListOptions.dataSource,
               dataItem,
               this.$wizardScope);

         this.treeListWidget.refresh();
         this.restoreExpandedItems = true;
      }
   }

   angular.module("com.vmware.vsphere.client.network")
         .controller("VmMigrateSelectVmsPageController",
               VmMigrateSelectVmsPageController);
}
